import { RouteObject } from "react-router-dom";
import RootOutlet from "./RootOutlet";
import {
  Home,
  lazyLoad,
  LandingGate,
  Heanuser,
  HomePage,
  Heanmenu,
  Heanrole,
  Heanoperatelog,
  Stripeuser,
  Stripeurl,
  Stripeaccount,
  Stripecheckout,
  Stripechannel,
  Shippinginfo,
  Payoutinfo,
  Paymentrecord,
  Payoutinfodeduction,
  Stripeblacklist,
  StShopify,
  Stripeusergroup,
  Heantenant,
  Paymentmethod,
  Stdraftorder,
  Transferorder,
  Xpaydoc,
  BaseDomain,

  Forget,
  Login,
  Register,
  Stripelog,
  Syncstripelog
} from "../pages";
export type IRouter = RouteObject & {};

export const mainRoutes: IRouter[] = [
  {
    path: "/",
    element: lazyLoad(<RootOutlet />),
    children: [
      {
        index: true,
        element: lazyLoad(<LandingGate />),
      },
      {
        element: lazyLoad(<Home />),
        children: [
      {
        path: "/home/index/:homeview?",
        element: lazyLoad(<HomePage.Home />),
      },
      // 账号管理
      {
        path: "/heanuser/page/list",
        element: lazyLoad(<Heanuser.HeanuserList />),
      },
      // 基础配置-链接域名
      {
        path: "/base/domain/list",
        element: lazyLoad(<BaseDomain.BaseDomainList />),
      },
      // shopify店铺管理
      {
        path: "/shop/shopify/list",
        element: lazyLoad(<StShopify.StShopifyPage />),
      },
      // 权限管理
      {
        path: "/permission/tenant",
        element: lazyLoad(<Heantenant.TenantList />),
      },
      {
        path: "/permission/menutree",
        element: lazyLoad(<Heanmenu.MenuTreeList />),
      },
      {
        path: "/permission/role",
        element: lazyLoad(<Heanrole.RoleList />),
      },

      //日志
      {
        path: "/log/operatelog/pagelist",
        element: lazyLoad(<Heanoperatelog.OperateLogPage />),
      },
      {
        path: "/log/loginlog/pagelist",
        element: lazyLoad(<Heanoperatelog.LoginLogPage />),
      },
      // 支付通道
      
      {
        path: "/payment/stripeusergroup/list",
        element: lazyLoad(<Stripeusergroup.StripeuserGroupPage />),
      },
      {
        path: "/payment/stripeuser/list",
        element: lazyLoad(<Stripeuser.StripeuserPage />),
      },
      {
        path: "/payment/stripeuser/createurl/:companyCode/:userId",
        element: lazyLoad(<Stripeuser.StripeuserCreateUrl />),
      },
      
      {
        path: "/payment/stripeurl/list",
        element: lazyLoad(<Stripeurl.StripeurlPage />),
      },
      {
        path: "/payment/stripeaccount/list",
        element: lazyLoad(<Stripeaccount.StripeaccountPage />),
      },

      {
        path: "/payment/stripecheckout/list",
        element: lazyLoad(<Stripecheckout.StripecheckoutPage />),
      },

      {
        path: "/payment/stripechannel/list",
        element: lazyLoad(<Stripechannel.StripechannelPage />),
      },
      {
        path: "/payment/method/list",
        element: lazyLoad(<Paymentmethod.PaymentmethodPage />),
      },

      

      //订单信息
      {
        path: "/order/stripelog/list",
        element: lazyLoad(<Stripelog.StripelogPage />),
      },
      {
        path: "/order/transferorder/list",
        element: lazyLoad(<Transferorder.TransferorderPage />),
      },
      {
        path: "/order/stdraftorder/list",
        element: lazyLoad(<Stdraftorder.StdraftorderPage />),
      },
      {
        path: "/order/deduction/list",
        element: lazyLoad(<Payoutinfodeduction.DeductionPage />),
      },  
      {
        path: "/order/syncstripelog/list",
        element: lazyLoad(<Syncstripelog.SyncstripelogPage />),
      },
      {
        path: "/order/shippinginfo/list",
        element: lazyLoad(<Shippinginfo.ShippinginfoPage />),
      },
      {
        path: "/order/stblack/list",
        element: lazyLoad(<Stripeblacklist.StBlackPage />),
      },

      

      

      //结算管理
      {
        path: "/settlement/manager/list",
        element: lazyLoad(<Payoutinfo.ManagerPage />),
      },
      {
        path: "/settlement/customer/list",
        element: lazyLoad(<Payoutinfo.CustomerPage />),
      },

      {
        path: "/settlement/opener/list",
        element: lazyLoad(<Payoutinfo.OpenerPage />),
      },

      {
        path: "/settlement/partner/list",
        element: lazyLoad(<Payoutinfo.PartnerPage />),
      },

      // 结算记录
      {
        path: "/settlement/paymentrecord/list",
        element: lazyLoad(<Paymentrecord.PaymentrecordPage />),
      },

      // Xpay 文档
      {
        path: "/xpaydoc/api/show",
        element: lazyLoad(<Xpaydoc.XpayApiShow />),
      },
      {
        path: "/xpaydoc/sdk/show",
        element: lazyLoad(<Xpaydoc.XpaySdkShow />),
      },
      {
        path: "/xpaydoc/api/edit",
        element: lazyLoad(<Xpaydoc.XpayApiEdit />),
      },
      {
        path: "/xpaydoc/sdk/edit",
        element: lazyLoad(<Xpaydoc.XpaySdkEdit />),
      },
        ],
      },
      {
        path: "/doc/:token",
        element: lazyLoad(<Xpaydoc.XpayDocShare />),
      },
    ],
  },
  {
    path: "/sign",
    children: [
      {
        path: "login",
        element: lazyLoad(<Login />),
      },
      {
        path: "register",
        element: lazyLoad(<Register />),
      },
      {
        path: "forget",
        element: lazyLoad(<Forget />),
      },
    ],
  },
];
